/**
 * Normalises a single-selection change event value into the array shape the
 * field value always uses. Clearing the selection (`undefined` / `null`)
 * yields an empty array; selecting a row yields a one-element array.
 */
export const toSingleSelectionValue = <T>(selected: T | null | undefined): T[] =>
	selected ? [selected] : [];
